'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
require('./SelectInput.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/**
 * Select input component
 */
var SelectInput = function SelectInput(_ref) {
  var options = _ref.options,
    name = _ref.name,
    onChange = _ref.onChange,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, ['options', 'name', 'onChange', 'value']);
  return _react2.default.createElement('select', _extends({
    className: 'c-select',
    name: name,
    onChange: onChange,
    value: value
  }, props), Object.entries(options).map(function (e) {
    return _react2.default.createElement('option', {
      key: e[0],
      value: e[0]
    }, e[1]);
  }));
};
SelectInput.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The options of this select input*/
  options: _propTypes2.default.object,
  /** The name attribute, containing a name that identifies the element when submitting the form */
  name: _propTypes2.default.string,
  /** Callback function that is fired when the checkbox value is changed */
  onChange: _propTypes2.default.func,
  /** Value selected from the options*/
  value: _propTypes2.default.string
} : {};
exports.default = SelectInput;